
export const getWaypointIcon = (fileName: string): string => {
    return `/waypoints/${fileName}.svg`;
}